import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import {
  Collapse, Box, List, Button,
} from '@mui/material';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const CollapsableNav = ({
  header, icon: Icon, children, isOpenAllSections, setOpenAllSections,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const pathtParts = location.pathname.split('/');

  const headerNormalized = header.toLowerCase().replace(/[^a-zA-Z]/g, '');

  useEffect(() => {
    if (typeof isOpenAllSections !== 'object') {
      setIsOpen(isOpenAllSections);
    }
  }, [isOpenAllSections]);

  const handleClick = () => {
    setIsOpen((c) => !c);
    setOpenAllSections(null);
  };

  return (
    <Box display="flex" flexDirection="column" className="collapsable-nav">
      <Button
        onClick={handleClick}
        className={classNames({ active: pathtParts.includes(headerNormalized) })}
      >
        {Icon && <Icon size="20" />}

        <span className="subheaderItem">{header}</span>

        <Box className={isOpen ? 'icon-collapsed' : 'icon-not-collapsed'}>
          <KeyboardArrowDownIcon className="chevron-icon" />
        </Box>
      </Button>

      <Collapse in={isOpen}>
        <List>
          {children}
        </List>
      </Collapse>
    </Box>
  );
};

CollapsableNav.propTypes = {
  header: PropTypes.string,
  children: PropTypes.any,
  icon: PropTypes.any,
  isOpenAllSections: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  setOpenAllSections: PropTypes.func,
};

export default CollapsableNav;
